export const PREFIX = 'NRBA'
export const DEFAULT_EXPIRES_MS = 14400000
export const DEFAULT_INACTIVE_MS = 1800000
